import {RaEvent, RaEventType} from "./RaEvent";


export enum DebugCommand {
    DEBUG_DIALOG,
    DEBUG_LOG,
    CORRECT_INPUT,
    INCORRECT_INPUT,
    SKIP_SENTENCE,
    SKIP_TEXT
}

export class DebugEvent extends RaEvent {

    static TYPE:RaEventType = "debug_event";

    constructor(public command: DebugCommand) {
        super(DebugEvent.TYPE);
    }
}